import { StatusField } from 'dash/resources/user/membership/StatusField'
import { ChannelIcon } from 'dash/shared/atoms/ChannelIcon'
import { EmptyListView } from 'dash/shared/EmptyListView'
import * as React from 'react'
import { CreateButton, Datagrid, List, SelectInput, TopToolbar, useRecordContext } from 'react-admin'
import AppState from 'shared/app_state'
import { channelLookup } from './types'

export const ChannelTypeField = () => {
  const record = useRecordContext()
  if (!record) return null

  const channel = channelLookup[record.type]

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ marginRight: 10 }}>
        <ChannelIcon channelType={channel} size={24} />
      </div>
      <div>
        <div>
          <strong>{channel.Name}</strong>
        </div>
        <div>{channel.summaryFor(record)}</div>
      </div>
    </div>
  )
}

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
)

const channelFilters = [
  <SelectInput
    alwaysOn
    key="channel-type-filter"
    source="type"
    choices={Object.keys(channelLookup)
      .sort()
      .map((cLKey) => {
        return {
          id: cLKey,
          name: (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ marginRight: 10 }}>
                <ChannelIcon channelType={channelLookup[cLKey]} size={24} />
              </div>
              <div>
                <div>{channelLookup[cLKey].Name}</div>
              </div>
            </div>
          ),
        }
      })}
  />,
]

export const ChannelList = () => {
  const accountId = AppState.getCurrentAccount()?.id
  return (
    <List
      actions={<ListActions />}
      filters={channelFilters}
      exporter={false}
      perPage={25}
      filter={{ accountId }}
      empty={<EmptyListView customMessage="No Channels yet." />}
    >
      <Datagrid rowClick="edit">
        <ChannelTypeField label="Channel" />
        <StatusField source="status" />
        {/* <NumberField source="notificationsCount" label="Notifications" /> */}
      </Datagrid>
    </List>
  )
}
